// removed by extract-text-webpack-plugin
module.exports = {"editableField":"_3L3xp-gjTEsf1ETPKjHZEt","normalField":"_1IjhyPGMox232gtgPHCAPA","editableExistField":"_3t9XwVWU2vwjeWwPIHS6_5"};


//////////////////
// WEBPACK FOOTER
// ./src/containers/Company/Company.css
// module id = 687
// module chunks = 0